module.exports = __webpack_public_path__ + "static/img/194_TO8_2091_og.09c5fc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/194_TO8_2091_og.jpg
// module id = GID6
// module chunks = 0